import React from 'react'
// import {CountUp} from 'react-countup/build/CountUp'
import CountUp from 'react-countup';
import ScrollTrigger from "react-scroll-trigger";
import './About.css'
// import Skills from '../Skills/Skills'
import { Button } from '@mui/material'
import { useState } from "react";


// import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'
// import {
//   Router as Routes,
 
//   Route,
//   Link
// } from "react-router-dom";


import mypic from '../About/zohaib.png'

export default function About() {
  
  const [counterOn, setCounterOn] = useState(false);
  
  return (
    <>
    {/* <div className='container'>
      <div className="col-lg-10 mx-auto">
      <div className="row">

        <div className="col-lg-5">
            <img src={mypic} className="my-pic" alt="" />
        </div>
        <div className="row col-lg-7">
          
           <div className="content">

            <h2>QAZI ZOHAIB ALI</h2>
            <h6>Frontend Developer</h6>
            <p>I am Front-End Web Developer with hands-on experience in optimizing & developing fully responsive, user-friendly and feature rich Websites and Web Applications. <br />
            i am reponsible to ensure that website visitors can easily interact with the page.
            </p>
            <p><strong>Expertise:</strong> FRONTEND WEB DEVELOPMENT</p>
            <p><strong>Experience:</strong> 1 YEAR</p>
            <p><strong>E-mail:</strong> qazizohaibali3@gmail.com</p>
           </div>
            <div>

            <button>Read More</button>
            </div>
              
            </div>
      </div>
      
        </div>
    </div> */}
    
     <div className="container mt-3" id='about'>

        <div className="col-lg-12">
          <div className="row mx-auto">
          <div className="col-lg-6 col-md-6 col-8 mx-auto my-pic-div">
          <img src={mypic} className="my-pic" alt="" />
          </div>
          <div className="col-lg-6 col-md-6 col-12 ">
          <div className="content mt-5 px-2">
            <h4 className='my_about'>About Me</h4>
            <h2 className=' about_name'>QAZI ZOHAIB ALI</h2>
            <h6 className='mt-2 about_title'>Frontend Developer</h6>
            <p className='mt-5 about_text'>I am Front-End Web Developer with hands-on experience in optimizing & developing fully responsive, user-friendly and feature rich Websites and Web Applications. <br />
            i am reponsible to ensure that website visitors can easily interact with the page.
            </p>
           
            <div className="my_counter">
            <ScrollTrigger
                      onEnter={() => setCounterOn(true)}
                      onExit={() => setCounterOn(false)}
                    >
              <div className="row d-flex flex-columns  first_part">

              <div className="projects col-6"><div className='counter_plus'> {counterOn && (<CountUp start={0} end={50} duration={4} delay={0} />)}+</div> Projects Completed</div>
              <div className="network col-6"><div className='counter_plus'>{counterOn && (<CountUp start={0} end={100} duration={2} delay={0}/>)}+</div> Comunity Network</div>
              </div>
              <div className="row d-flex flex-columns sec_part">
              <div className="contract col-6"><div className='counter_plus'>{counterOn && (<CountUp start={0} end={20} duration={3} delay={0}/>)}+</div>Contract Remote</div>
              <div className="experience col-6"><div className='counter_plus'>{counterOn && (<CountUp start={0} end={6} duration={4} delay={0}/>)}+</div>Month's Experience</div>

              </div>
              </ScrollTrigger>
            </div>
            
            {/* <p className='mt-4 about_secpart'><strong>Expertise:</strong> FRONTEND WEB DEVELOPMENT</p>
            <p className='mt-2 about_secpart'><strong>Experience:</strong> 1 YEAR</p>
            <p className='mt-2 about_secpart'><strong>E-mail:</strong> qazizohaibali3@gmail.com</p> */}
           </div>
        <Button variant="contained" className='mx-2 mt-5' color='warning'><strong> 
        READ MORE
         
         </strong></Button>
         
           
          </div>
        </div>
        </div>
     
     </div>
    
    </>
  )
}
